module.exports = __webpack_public_path__ + "static/media/institutions-icon-1.d79fcca9.svg";